var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"follower",style:({ top: _vm.y + 'px', left: _vm.x + 'px' })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }